import { createApiCall } from 'lib/base';

interface EditFundProductBody {
  name: string;
  description: string;
  logo: string;
}

const EDIT_FUND_PRODUCT = 'EDIT_FUND_PRODUCT';

export const editFundProductApi = createApiCall<
  EditFundProductBody & { id: string; payload: any }
>(EDIT_FUND_PRODUCT, ({ id, payload }) => ({
  endpoint: `api/admin/fund-products/${id}`,
  method: 'PUT',
  body: payload,
}));

export default editFundProductApi;
